import React from 'react';

import { PayPalButton } from './base';

interface PayPalPaymentButton {
  className?: string;
  amount: number;
  onSuccess: () => void;
}

export const PayPalPaymentButton: React.FC<PayPalPaymentButton> = ({
  className,
  amount,
  onSuccess,
}) => {
  const createOrder = (_data: any, actions: any) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: amount.toFixed(2),
          },
        },
      ],
    });
  };

  const onApprove = async (_data: any, actions: any) => {
    await actions.order.capture();

    onSuccess();
  };

  return (
    <div className={className}>
      <PayPalButton
        style={{
          layout: 'vertical',
          color: 'blue',
          tagline: false,
          size: 'responsive',
          height: 55,
        }}
        createOrder={createOrder}
        onApprove={onApprove}
      />
    </div>
  );
};

export default PayPalPaymentButton;
